import React from 'react';
import _ from 'lodash';
import {
    IonSelectOption
} from '@ionic/react'

function CustomPropertySelect({ propertiesArray = [] }) {
  return (
    <>
      {propertiesArray.length === 1 ? (
        <IonSelectOption key={propertiesArray[0].propertyId} value={propertiesArray[0].propertyId}>
          {propertiesArray[0].propertyName}
        </IonSelectOption>
      ) : (
        <>
          <IonSelectOption key={''} value={''}>
            All Properties
          </IonSelectOption>
          {_.map(propertiesArray, (property, index) => (
            <IonSelectOption key={property.propertyId} value={property.propertyId}>
              {property.propertyName}
            </IonSelectOption>
          ))}
        </>
      )}
    </>
  );
}

export default CustomPropertySelect;
